import ContentItemContainer
  from '@components/Widgets/_contentItems/_contentItemContainer.vue'
import pxToEm from '@shared/components/mixins/shared/pxToEm'
import { position } from '@meta/widget/options'
import CloseButton
  from '@components/Widgets/_global/CloseButton/CloseButton.vue'

export default {
  name: 'TwoColumnStepPreview',
  mixins: [pxToEm],
  props: {
    widget: {
      required: true,
      type: Object,
    },
    targetStepIndex: {
      required: true,
      type: Number,
    },
  },
  components: {
    'content-item-container': ContentItemContainer,
    'close-button': CloseButton,
  },
  data() {
    return {
      positionOptions: position,
    }
  },
  computed: {
    widgetSide() {
      const rightPositions = [
        this.positionOptions.TOP_RIGHT,
        this.positionOptions.CENTER_RIGHT,
        this.positionOptions.BOTTOM_RIGHT,
      ]
      return rightPositions.includes(this.widget.settings.position)
        ? 'right'
        : 'left'
    },
    leftColumnItems() {
      // contentItems is an array of objects
      const contentItems = this.widget.steps[this.targetStepIndex]?.contentItems ||
        []

      // Filter items that have column === 'A'
      return contentItems.filter(item => item.column === 'A')
    },
    rightColumnItems() {
      const contentItems = this.widget.steps[this.targetStepIndex]?.contentItems ||
        []

      // Filter items that have column === 'B'
      return contentItems.filter(item => item.column === 'B')
    },
  },
}
